import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Image } from 'foundations-components/transitional/components/Image';
import { H4 } from 'foundations-components/transitional/components/H4';
// @ts-expect-error Could not find a declaration file for module
import abstractCardImage from 'bender-url!../../../../images/content-empty-icon.svg';
//@ts-expect-error Could not find declaration file for module
import playlistTableUrl from 'bender-url!../../../../images/playlist-table.svg';
import BlankPageMediaWrapper from '../../../components/BlankPageMediaWrapper';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useMyPlaylistsParams } from '../../myPlaylists/myPlaylistsHooks';
import { View } from 'foundations-components/components/View';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SavedItemsEmpty = ({
  itemKey
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const showAssignmentsBlankContent = itemKey === 'myPlaylists';
  const {
    tab
  } = useMyPlaylistsParams();
  const itemRightComponent = useCallback(props => {
    return /*#__PURE__*/_jsx(Image, Object.assign({
      src: showAssignmentsBlankContent ? playlistTableUrl : abstractCardImage
    }, props));
  }, [showAssignmentsBlankContent]);
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": `${itemKey}-empty`,
    marginBlockEnd: "400",
    marginBlockStart: isMobile ? '600' : undefined,
    children: /*#__PURE__*/_jsxs(BlankPageMediaWrapper, {
      itemRightComponent: itemRightComponent,
      children: [/*#__PURE__*/_jsx(H4, {
        children: showAssignmentsBlankContent ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.myPlaylists.tab.${tab}.blankHeader`
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.savedItems.${itemKey}.emptyHeading`
        })
      }), /*#__PURE__*/_jsx("p", {
        children: showAssignmentsBlankContent ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `learningCenter.myPlaylists.tab.${tab}.blankBody`
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.savedItems.${itemKey}.emptyBody`
        })
      })]
    })
  });
};
export default SavedItemsEmpty;